export default "__VITE_ASSET__20de2162__"